import { useEffect, useState } from "react";
import ContentRenderer from "../../_default/ContentRenderer";
import { useAppSelector } from "../../../store/hooks";
import AddHeaderOrFooter from "./AddHeaderOrFooter";
import React from "react";
import { getComponentFromStructureMap } from "../../_default/utilities/componentIdentity";

export default function BuilderContent() {
  const website = useAppSelector((state) => state.builder.website);
  const colors = useAppSelector((state) => state.builder.colors);
  const pages = useAppSelector((state) => state.builder.pages);

  const [headerSettingsVisibility, setHeaderSettingsVisibility] =
    useState(false);

  const [footerSettingsVisibility, setFooterSettingsVisibility] =
    useState(true);

  const structure = useAppSelector((state) => state.builder.structure);

  useEffect(() => {
    document.body.style.fontSize = website.baseFontSize;

    colors.forEach((color) => {
      if (color.name === "GLOBALBACKGROUNDCOLOR") {
        document.body.style.backgroundColor = color.color;
      }
    });

    document.getElementsByTagName("html")[0].style.fontSize =
      website.baseFontSize;
  }, [website.baseFontSize, colors]);

  useEffect(() => {
    const hasFooter = structure.webpageComponents.some((x) => {
      return getComponentFromStructureMap(structure.components, x)?.type === "footer";
    });

    if (hasFooter && footerSettingsVisibility === false) {
      setFooterSettingsVisibility(false);
    } else if (!hasFooter && footerSettingsVisibility === true) {
      setFooterSettingsVisibility(true);
    } else if (hasFooter && footerSettingsVisibility === true) {
      setFooterSettingsVisibility(false);
    } else if (!hasFooter && footerSettingsVisibility === false) {
      setFooterSettingsVisibility(true);
    }
  }, [structure, pages.active]);

  useEffect(() => {
    const hasHeader = structure.webpageComponents.some((x) => {
      return getComponentFromStructureMap(structure.components, x)?.type === "header";
    });

    if (hasHeader && headerSettingsVisibility === false) {
      setHeaderSettingsVisibility(false);
    } else if (!hasHeader && headerSettingsVisibility === true) {
      setHeaderSettingsVisibility(true);
    } else if (hasHeader && headerSettingsVisibility === true) {
      setHeaderSettingsVisibility(false);
    } else if (!hasHeader && headerSettingsVisibility === false) {
      setHeaderSettingsVisibility(true);
    }
  }, [structure, pages.active]);

  return (
    <div id="BuilderContent" className="builder__content-container">
      {headerSettingsVisibility && <AddHeaderOrFooter typeName="header" />}
      <ContentRenderer />
      {footerSettingsVisibility && <AddHeaderOrFooter typeName="footer" />}
    </div>
  );
}
